
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FilestoreBrowserComponent } from './filestore-browser/filestore-browser.component';


const routes: Routes = [
  { component: FilestoreBrowserComponent, path:''}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FileStoreRoutingModule { }
